import React, { ReactNode } from "react";
import { Button, Form } from "react-bootstrap";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PlusCircle } from "react-bootstrap-icons";
import Branding from "../../config/Branding";
import FilterGroupCard from "./FilterGroupCard";

type ConditionalFiltersEditorProps = {
    conditionalFilters: ConditionalFilters;
    availableFilters: Array<DropdownFilter>;
    customerConfig: CustomerConfig;
    onChange: (conditionalFilters: ConditionalFilters) => void;
};

/**
 * Top-level editor for conditional filters.
 * Renders a list of FilterGroupCards (each with AND/OR operator) that are ANDed together.
 */
export default class ConditionalFiltersEditor extends React.Component<ConditionalFiltersEditorProps> {
    private handleTopLevelOperatorChange = (operator: "AND" | "OR"): void => {
        this.props.onChange({ ...this.props.conditionalFilters, operator });
    };

    private handleGroupUpdate = (index: number, group: FilterGroup): void => {
        const groups = [...this.props.conditionalFilters.groups];
        groups[index] = group;
        this.props.onChange({ ...this.props.conditionalFilters, groups });
    };

    private handleGroupRemove = (index: number): void => {
        const groups = this.props.conditionalFilters.groups.filter((_, i) => i !== index);
        this.props.onChange({ ...this.props.conditionalFilters, groups });
    };

    private handleAddGroup = (): void => {
        const newGroup: FilterGroup = {
            operator: "AND",
            conditions: [{ topic: "", values: [] }]
        };
        this.props.onChange({
            ...this.props.conditionalFilters,
            groups: [...this.props.conditionalFilters.groups, newGroup]
        });
    };

    public render(): ReactNode {
        const { conditionalFilters, availableFilters, customerConfig } = this.props;
        const hasGroups = conditionalFilters.groups.length > 0;

        return (
            <div>
                {/* Top-level operator selector */}
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                    <span style={{ color: "#aaa", fontSize: 12 }}>Where</span>
                    <Form.Control
                        as="select"
                        size="sm"
                        value={conditionalFilters.operator}
                        onChange={(e: any) => this.handleTopLevelOperatorChange(e.target.value as "AND" | "OR")}
                        style={{ width: "auto", fontSize: 12, backgroundColor: "#1a1a2e", color: Branding.white, border: "1px solid #444" }}
                    >
                        <option value="AND">all of these match</option>
                        <option value="OR">any of these match</option>
                    </Form.Control>
                </div>

                {!hasGroups && (
                    <div style={{
                        color: "#666",
                        fontSize: 13,
                        fontStyle: "italic",
                        marginBottom: 12,
                        padding: "10px",
                        border: "1px dashed #333",
                        borderRadius: 4,
                        textAlign: "center"
                    }}>
                        No filters configured. Add a group to restrict results.
                    </div>
                )}

                {conditionalFilters.groups.map((group, i) => (
                    <FilterGroupCard
                        key={`group-${i}`}
                        group={group}
                        groupIndex={i}
                        topLevelOperator={conditionalFilters.operator}
                        availableFilters={availableFilters}
                        customerConfig={customerConfig}
                        onUpdate={(g) => this.handleGroupUpdate(i, g)}
                        onRemove={() => this.handleGroupRemove(i)}
                    />
                ))}

                {/* Add group button */}
                <div style={{ textAlign: "left", marginTop: 4 }}>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={this.handleAddGroup}
                        disabled={availableFilters.length === 0}
                        style={{ fontSize: 12 }}
                    >
                        <PlusCircle size={13} style={{ marginRight: 5 }} />
                        Add Filter Group
                    </Button>
                </div>
            </div>
        );
    }
}

